// For the default shapes, we only allow Rounded and Straight right now, because most
// components don't work well with 'full', for example.
// Actually, the only thing we

// Shapes in use by individual components
export enum ThemeShape {
  Straight = 'straight',
  Rounded = 'rounded',
  Curved = 'curved',
  Smooth = 'smooth',
  Full = 'full',
}

export function useThemeShapes() {
  const { themeConfig } = useThemeConfig()

  const defaultShapes = computed <Record<string, ThemeShape>>(() => {
    const shape = (themeConfig.value?.defaultShape || ThemeShape.Rounded) as ThemeShape

    return {
      accordion: shape,
      autocompleteItem: shape,
      avatar: ThemeShape.Full,
      button: shape == ThemeShape.Rounded ? ThemeShape.Full : shape,
      buttonAction: shape,
      buttonIcon: shape,
      buttonClose: shape,
      card: shape,
      dropdown: shape,
      iconBox: shape,
      input: shape,
      message: shape,
      pagination: shape,
      progress: shape,
      prose: shape,
      tabSlider: shape,
    }
  })

  return {
    defaultShapes,
  }
}
